import type { FC } from "react"

interface MaskedIconProps {
  src?: string
  width?: number
  strokeColor?: string
  strokeWidth?: number
  additionalStyle?: string
}

export const MaskedIcon: FC<MaskedIconProps> = ({
  width = 24,
  strokeColor = "#1D2028",
  strokeWidth = 0.5,
  src,
  additionalStyle,
}) => {
  const maskId = `mask-${Math.random().toString(36).substring(2, 9)}`
  const patternId = `pattern-${Math.random().toString(36).substring(2, 9)}`
  const imageId = `image-${Math.random().toString(36).substring(2, 9)}`

  return (
    <svg
      className={additionalStyle}
      fill="none"
      height={width}
      viewBox="0 0 24 24"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <mask
        height={24}
        id={maskId}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
        width={24}
        x={0}
        y={0}
      >
        <path
          d="M24 12.012c0 4.432-2.176 7.831-5.76 9.921C16.483 22.967 14.197 24 11.999 24 5.38 24 .545 20.256.018 12.012c-.176-2.848.989-5.467 2.66-7.534.989-1.217 2.857-2.25 4.264-3.008C8.635.528 9.932 0 12.02 0c4.132 0 7.342 2.09 9.496 5.282C22.813 7.234 24 9.532 24 12.012"
          fill="#D9D9D9"
        />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path d="M0 0h24v24H0z" fill={`url(#${patternId})`} />
      </g>
      <path
        d="M18.115 21.717h-.001c-1.749 1.028-3.987 2.033-6.116 2.033-3.262 0-6.058-.922-8.103-2.835S.528 16.072.267 11.995c-.17-2.767.961-5.326 2.605-7.36.47-.578 1.16-1.125 1.919-1.624.756-.499 1.566-.942 2.27-1.321l.002-.002C8.735.758 9.99.25 12.02.25c4.035 0 7.172 2.036 9.288 5.171 1.29 1.943 2.442 4.187 2.442 6.59 0 4.338-2.124 7.658-5.635 9.706Z"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
      />
      <defs>
        <pattern height={1} id={patternId} patternContentUnits="objectBoundingBox" width={1}>
          <use transform="scale(.00595)" xlinkHref={`#${imageId}`} />
        </pattern>
        {src && (
          <image height={168} id={imageId} preserveAspectRatio="none" width={168} xlinkHref={src} />
        )}
      </defs>
    </svg>
  )
}
